/**
 * CR550: Simple hook for checking a single feature flag reactively
 */

import { useState, useEffect } from "react";
import { isFeatureEnabled, type FeatureFlagName } from "@/lib/featureFlags";

/** Returns true/false for a single flag (defaults to false while loading) */
export function useFeatureFlag(flagName: FeatureFlagName): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    isFeatureEnabled(flagName).then((val) => {
      if (!cancelled) setEnabled(val);
    });
    return () => { cancelled = true; };
  }, [flagName]);

  return enabled;
}
